export default {
  initDevice() {
    return new Promise(resolve => {
      const cordovaScript = document.createElement("script")
      cordovaScript.setAttribute("src", "cordova.js")
      document.head.appendChild(cordovaScript)
      document.addEventListener(
        "deviceready",
        () => {
          window.keepscreenon.enable()
          resolve()
        },
        false
      )
    })
  },
  getDeviceId() {
    if (window.device == null) {
      return null
    }
    return window.device.uuid
  }
}
